import { Table } from 'antd';
import { useContext, useEffect, useState } from 'react';
import Axios from 'axios';
import CustomPagination from 'components/table/pagination';
import DashboardContext from 'Context';

export default function WorkerFavlist({ id }) {
  const { urldashboard, authentication } = useContext(DashboardContext);
  // table data
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecord, setTotalRecord] = useState(0);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
  });

  useEffect(() => {
    getWorkerSchedule({
      page: pagination?.page,
      pageSize: pagination?.pageSize,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getWorkerSchedule = async ({ page, pageSize }) => {
    setLoading(true);
    try {
      let url = `/worker/getFavorited/${
        id || sessionStorage.getItem('workerId')
      }`;
      const res = await Axios.get(urldashboard + url, {
        headers: {
          Authorization: authentication,
          'Content-Type': 'application/json',
        },
        params: {
          page,
          pageSize,
        },
      });
      const data = await res.data;
      const items = data?.data?.map((obj) => ({ ...obj, key: obj.id }));
      setData(items);
      setTotalRecord(data?.totalRecord);
      setPagination({
        page: page,
        pageSize: pageSize,
        total: data?.totalRecord,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setData([]);
    }
  };

  const handlePagination = (newPage, newPageSize) => {
    getWorkerSchedule({
      page: newPage,
      pageSize: newPageSize,
    });
  };

  const columns = [
    {
      title: 'ردیف',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg'],
      render: (_, record, index) => (
        <>{index + 1 + (pagination?.page - 1) * pagination?.pageSize}</>
      ),
    },
    {
      title: 'نوع بیزینس',
      dataIndex: 'businessTypeTitle',
      key: 'businessTypeTitle',
      responsive: ['xl', 'lg'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'نام مشتری/شرکت',
      dataIndex: 'companyName',
      key: 'companyName',
      align: 'center',
      render: (value, record) => (
        <span>
          {value ? value : record?.customerName ? record?.customerName : '-'}
        </span>
      ),
    },
    {
      title: 'آدرس',
      dataIndex: 'address',
      key: 'address',
      responsive: ['xl', 'lg'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
  ];

  return (
    <>
      <Table
        size='small'
        rowClassName={() => 'center'}
        columns={columns}
        bordered={true}
        dataSource={data}
        loading={loading}
        pagination={false}
        locale={{
          emptyText: 'موردی یافت نشد',
        }}
      />

      {!loading && (
        <CustomPagination
          totalRecord={totalRecord}
          pagination={pagination}
          handlePagination={handlePagination}
        />
      )}
    </>
  );
}
